import React, { useState } from "react";
import {
  Box,
  Button,
  Flex,
  IconButton,
  Input,
  Text,
  VStack,
  useToast,
} from "@chakra-ui/react";
import { CloseIcon } from "@chakra-ui/icons";

const FileUpload = ({ files, setFiles }) => {
  const toast = useToast();

  const handleFileChange = (event) => {
    const selectedFiles = Array.from(event.target.files);
    console.log(selectedFiles)

    const validFiles = selectedFiles.filter(
      (file) =>
        [
          "text/plain",
          "image/png",
          "image/jpeg",
          "application/pdf",
          "text/csv",
          "application/x-zip-compressed",
          "application/zip",
        ].includes(file.type) && file.size <= 5 * 1024 * 1024 
    );

    if (validFiles.length + files.length > 3) {
      toast({
        title: "Limite excedido",
        description: "Você pode anexar no máximo 3 arquivos.",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
      return;
    }

    setFiles((prevFiles) => [...prevFiles, ...validFiles]);
  };

  const removeFile = (index) => {
    setFiles(files.filter((_, i) => i !== index));
  };

  return (
    <Box
      bg="white"
      p={4}
      w="100%"
      maxW="100%"
      mx="auto"
      mt={5}
      border="1px solid"
      borderColor="gray.200"
      borderRadius="lg"
    >
      <Text fontSize="sm" fontWeight="medium" color="gray.700">
        Anexar Arquivos
      </Text>
      <Input
        type="file"
        multiple
        onChange={handleFileChange}
        mt={2}
        p={2}
        border="1px solid"
        borderColor="gray.300"
        borderRadius="md"
        accept=".txt,.png,.jpg,.jpeg,.pdf,.csv,.zip" // Incluindo .zip
      />
      
      {/* Texto explicativo sobre os arquivos permitidos */}
      <Text fontSize="xs" color="gray.500" mt={2}>
        Tipos de arquivos permitidos: .txt, .png, .jpg, .jpeg, .pdf, .csv, .zip <br />
        Tamanho máximo: 5MB por arquivo <br />
        Máximo de 3 arquivos
      </Text>

      {files.length > 0 && (
        <VStack align="stretch" spacing={2} mt={4}>
          <Text fontSize="sm" fontWeight="semibold">
            Arquivos selecionados:
          </Text>
          {files.map((file, index) => (
            <Flex
              key={index}
              align="center"
              justify="space-between"
              p={2}
              bg="gray.100"
              borderRadius="md"
            >
              <Text fontSize="sm" isTruncated maxW="200px">
                {file.name}
              </Text>
              <IconButton
                icon={<CloseIcon boxSize={3} />}
                size="xs"
                colorScheme="red"
                variant="ghost"
                onClick={() => removeFile(index)}
              />
            </Flex>
          ))}
        </VStack>
      )}
    </Box>
  );
};

export default FileUpload;
